import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { TeamIcon } from '../../../../../../common/react/components/TeamIcon';
import { MatchStatus } from '../MatchStatus';
import { MatchCardEvent } from './MatchCardEvent';

export const MatchCardRegular = ( { matchInfo } ) => {
    const dispatch = useDispatch();

    useEffect( () => {
        const matchInfoStatus = PULSE.app.common.match.getMatchStatus( matchInfo.status );

        // to be set up only for live matches, matches starting soon, or past start time but not yet complete
        if ( matchInfoStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE ||
             PULSE.app.common.match.startsWithinAnHour( matchInfoStatus, matchInfo.utcStartTime ) ||
             ( PULSE.app.common.match.isPastStartTime( matchInfo.utcStartTime ) &&
               matchInfoStatus !== PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED )
        ) {
            dispatch(
                // @ts-expect-error
                window.PULSE.app.redux.actions.match
                    .ADD_MATCH
                    .request( matchInfo.providerId )
            );
        }
    }, [] );

    const liveMatch = useSelector( state => window.PULSE.app.redux.selectors.match.item( state, matchInfo.providerId ) );

    let match = liveMatch || matchInfo;

    if ( !liveMatch ) {
        match.abbr = `${matchInfo.home.team.nickname} v ${matchInfo.away.team.nickname}`;
        match.homeScore = match.home.score?.totalScore;
        match.awayScore = match.away.score?.totalScore;
        match.homeTeamAbbr = match.home.team.abbreviation.toLowerCase();
        match.homeTeamPid = match.home.team.providerId;
        match.awayTeamAbbr = match.away.team.abbreviation.toLowerCase();
        match.awayTeamPid = match.away.team.providerId;
    } else {
        match.homeScore = match.score?.homeTeamScore.matchScore.totalScore;
        match.awayScore = match.score?.awayTeamScore.matchScore.totalScore;
        match.homeTeamAbbr = match.match.homeTeam.abbr.toLowerCase();
        match.homeTeamPid = match.match.homeTeamId;
        match.awayTeamAbbr = match.match.awayTeam.abbr.toLowerCase();
        match.awayTeamPid = match.match.awayTeamId;
        match.status = match.match.status;
    }

    const genericStatus = PULSE.app.common.match.getMatchStatus( match.status );
    const isCompleted = genericStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED;

    return (
        <a href={PULSE.app.common.url.getMatchURL( matchInfo )} className="fb-match" aria-label={`${match.abbr}`}>
            <div className={`fb-match__row ${ isCompleted && match.homeScore < match.awayScore ? 'fb-match__row-lost' : ''}`}>
                <div className="fb-match__team-container">
                    <span className="fb-match__logo">
                        <TeamIcon
                            className="fb-match__logo-icon"
                            providerId={ match.homeTeamPid }
                        />
                    </span>
                    <span>{match.homeTeamAbbr}</span>
                </div>
                <span className="fb-match__score-home">{match.homeScore}</span>
            </div>
            <div className={`fb-match__away fb-match__row ${ isCompleted && match.awayScore < match.homeScore ? 'fb-match__row-lost' : ''}`}>
                <div className="fb-match__team-container">
                    <span className="fb-match__logo">
                        <TeamIcon
                            className="fb-match__logo-icon"
                            providerId={ match.awayTeamPid }
                        />
                    </span>
                    <span>{match.awayTeamAbbr}</span>
                </div>
                <span className="fb-match__score-away">{match.awayScore}</span>
            </div>
            <MatchStatus utcStartTime={ matchInfo.utcStartTime } match={match}></MatchStatus>
            { matchInfo && <MatchCardEvent matchInfo={matchInfo}></MatchCardEvent>}
        </a>
    );
};

MatchCardRegular.propTypes = {
    matchInfo: PropTypes.object.isRequired
};